export type IProgram = {
	id: string;
	_id: string;
	name: string;
};

export interface ProgramParameters {
	eligibility: boolean;
	consent: boolean;
	maxBeneficiaries: number;
	durationInWeeks: number;
	maxYearlyEarnings: number;
	budgetLimit: number;
	baseIncentiveNegative: number;
	baseIncentivePositive: number;
	biVisitIncrementNegative: number;
	repetitionPerSteps: number;
	_id?: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	durationConfig?: any;
}

export interface Program {
	_id: string;
	id: string;
	accountId: string;
	name: string;
	type: "Stim" | "OUD";
	status: "ACTIVE" | "INACTIVE";
	multiTreatmentPlan: boolean;
	treatmentPlanChangeAllowed: boolean;
	treatmentPlan?: string;
	orgUnitId?: string[];
	parameters: ProgramParameters;
	createdBy: string;
	createdAt: string;
	updatedAt: string;
	cmRoles?: string[];
	additionalStaffRoles?: string[];
	payers?: string[];
}

export interface ProgramRequest {
	accountId: string;
	name: string;
	type: "Stim" | "OUD";
	status: "ACTIVE" | "INACTIVE";
	multiTreatmentPlan: boolean;
	treatmentPlanChangeAllowed: boolean;
	treatmentPlan?: string;
	orgUnitId?: string[];
	parameters: ProgramParameters;
	createdBy: string;
	cmRoles?: string[];
	additionalStaffRoles?: string[];
	payers?: string[];
}

export type Params = {
	accountId: string;
	userId?: string;
};

export enum IncentiveTypes {
	GC = "GC",
	PPC = "PPC",
}
